import * as React from 'react';
import Select from 'react-select';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

import { AppFormField, AppFormFieldProps, AppFormFieldOwnProps } from './appFormField';
import styles from './appSelectField.module.scss';

export interface AppSelectFieldOwnProps extends AppFormFieldOwnProps {
  options: any[];
  onChangeCallback?: (value: any) => void;
  multi?: boolean;
  defaultKey?: any;
}

const parseValue = (selected: any) => {
  if (isArray(selected)) {
    return selected.map(item => {
      if (isObject(item)) {
        return (item as any).value;
      }

      return item;
    });
  }

  if (isObject(selected)) {
    return (selected as any).value;
  }

  return selected;
};

const handleOnChange = (onChange: Function, onChangeCallback?: Function) => (value: any) => {
  onChange(parseValue(value));

  if (typeof onChangeCallback === 'function') {
    onChangeCallback(value);
  }
};

const getValue = (selected: any, options: any[]) => {
  if (isArray(selected)) {
    return options.filter(option => selected.some(v => option.value === v));
  }

  return options.find(option => option.value === selected) || selected;
};

export class AppSelectField extends AppFormField<AppSelectFieldOwnProps> {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    const { multi = false, disabled, defaultKey } = this.props;

    return (
      <Select
        isSearchable
        className={styles.selectField}
        onChange={handleOnChange(field.input.onChange, this.props.onChangeCallback)}
        value={getValue(field.input.value || defaultKey, this.props.options)}
        options={this.props.options}
        classNamePrefix="appSelectField"
        isMulti={multi}
        isDisabled={disabled}
        menuShouldBlockScroll
        menuPortalTarget={document.body}
        styles={{ menuPortal: menuPortalStyles => ({ ...menuPortalStyles, zIndex: 9999 }) }}
      />
    );
  }
}
